<template>
  <LinkCard
    :icon="['fal', 'browser']"
    :image="thumbnail"
    :title="$path('name', value)"
    :is-list="isList"
    :badges="badges"
    theme="light"
    :to="$attrs.to || { name: 'page-dashboard', params: { id: value.id }, query: $route.query }"
    class="page-link-card"
  >
    <template #subtitle>
      <StatusIndicator v-bind="status" />
    </template>
  </LinkCard>
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'
import { thumbhashToBase64 } from '@/utils/thumbhash'

export default {
  props: {
    value: Object,
    theme: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    isList() {
      return this.theme === 'list'
    },
    thumbnail() {
      let logo = this.$path('media.logo', this.value)
      if (!logo) return
      return { src: logo.url, size: 'contain', preview: thumbhashToBase64(logo) }
    },
    status() {
      if (this.value.isArchived) return { label: this.$t('archived'), status: 'warning' }
      if (this.value.isPublished) return { label: this.$t('published'), status: 'success' }
      return { label: this.$t('unpublished'), status: 'error' }
    },
    badges() {
      if (!this.value.demo) return []
      return [{ value: this.$t('demo'), theme: 'warning' }]
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>

<style lang="scss">
.page-link-card {
  .image {
    padding: 1.5rem;
  }
}
</style>
